import { message, Modal } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { setEmailDefaultInfo } from 'components/UIBuilder/SectionFunction/Common';
import * as lodash from 'lodash';
import { store } from 'appRedux/store';
import { startAiExtraction } from 'appRedux/actions/AiExtraction';
import { setAiActivePage } from 'util/aiExtractionPageRef';

let canSearch = true;

// Document section「AI」按钮：把勾选文档交给 AI 抽取 property + JobContact（非阻塞）。
// 任务态进 Redux → 右上浮动按钮提示处理中，完成后自动弹出右侧抽屉。
export function useAI({ sectionComponent, pageComponent } = {}) {
  const selectedRowKeys = sectionComponent.child.current?.state.selectedRowKeys || [];
  if (selectedRowKeys.length === 0) {
    message.warning('You must select at least one document.');
    return;
  }
  // 上一个任务还在分析中则不重复发起（纯前端单任务）
  if (store.getState().aiExtraction.status === 'processing') {
    message.warning('AI is still analysing documents. Please wait for it to finish.');
    return;
  }

  const jobData = pageComponent.state.jobData;
  // 记录当前页引用，供全局抽屉写回成功后刷新本页 section
  setAiActivePage(pageComponent);
  // selectedRowKeys 即文档 Id（与 batchDelete/batchDownload 一致）
  store.dispatch(startAiExtraction({
    jobId: jobData.JobId,
    moduleId: jobData.ModuleId,
    documentIds: selectedRowKeys,
  }));
  clearSelectedRowKeys(sectionComponent);
  message.info('AI is analysing the selected document(s)…');
}

//设置CloudEdit的Icon
export function formatData({ pageComponent, sectionComponent, parameter } = {}) {
  let data = parameter.map((folder, i) => {
    if (sectionComponent.state.collapseFolderIds.indexOf(folder.key) >= 0) {
      folder.Collapsed = true;
    }
    return folder;
  });

  switch (pageComponent.props.authUser.Company.CloudEditSyncProvider) {
    case 'Dropbox':
    case 'Microsoft 365':
      data = parameter.map((folder) => {
        folder.DocumentList.map((item) => {
          if (!globalFunction.isNullOrEmpty(item.CloudDocPath)) {
            let iconFormat = [];
            iconFormat.push({ actionType: 'CloudEdit', iconIndex: 1, href: item.Href });
            item.IconFormat = iconFormat;
          }
          return item;
        });
      });
      break;
  }
  return data;
}

//DocumentType过滤器
export function getSectionDataByDocumentType({ sectionName, parameter, sectionComponent, pageComponent, uie, loadData = true } = {}) {
  if (sectionComponent.state.componentDataSource[uie.source] !== undefined) {
    let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
    componentDefaultValue[uie.source] = parameter;
    let searchParameter = { ...sectionComponent.state.searchParameter };
    searchParameter.DocumentTypeId = parameter;
    searchParameter.jobId = sectionComponent.props.searchParameter.jobId;
    sectionComponent.setState({ searchParameter, componentDefaultValue });
    pageComponent.setState({ DocumentTypeId: parameter });

    if (loadData) {
      setTimeout(() => {
        if (canSearch && sectionComponent.state.searchParameter !== null && sectionComponent.state.searchParameter.DocumentTypeId != undefined && sectionComponent.state.searchParameter.ShareControl != undefined) {
          sectionComponent.getSectionDataByDefault();
          canSearch = false;
          setTimeout(() => {
            canSearch = true;
          }, 100);
        }
      }, config.setTimeoutMilliSecond);
    }
  }
}

//ShareControl过滤器
export function getSectionDataByShareControl({ sectionName, parameter, sectionComponent, pageComponent, uie, loadData = true } = {}) {
  if (sectionComponent.state.componentDataSource[uie.source] !== undefined) {
    let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
    componentDefaultValue[uie.source] = parameter;
    let searchParameter = { ...sectionComponent.state.searchParameter };
    searchParameter.ShareControl = parameter;
    searchParameter.jobId = sectionComponent.props.searchParameter.jobId;
    sectionComponent.setState({ searchParameter, componentDefaultValue });
    pageComponent.setState({ ShareControl: parameter });

    if (loadData) {
      setTimeout(() => {
        if (canSearch && sectionComponent.state.searchParameter?.DocumentTypeId != undefined && sectionComponent.state.searchParameter?.ShareControl != undefined) {
          sectionComponent.getSectionDataByDefault();
          canSearch = false;
          setTimeout(() => {
            canSearch = true;
          }, 100);
        }
      }, config.setTimeoutMilliSecond);
    }
  }
}


//Document点击添加按钮逻辑
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ uploadType: '' });
  sectionComponent.child.current?.setState({ uploadDocumentShow: true });
  sectionComponent.child.current?.uploadDocument.current?.setState({
    submitting: false,
    jobDocumentFolderId: null
  });


  if (sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.ShareControl === undefined) {
    httpClient
      .get('System/SelectOption/GetShareControlAbbreviationList')
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            dataSource = dataSource.filter(item => item.Value !== 0);
            let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
            componentDataSource.ShareControl = dataSource;
            sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
            sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('ShareControl', []);
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    setTimeout(() => {
      let dataSource = sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.ShareControl;
      dataSource = dataSource.filter(item => item.Value !== 0);
      let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
      componentDataSource.ShareControl = dataSource;
      sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
      sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('ShareControl', []);
    }, config.setTimeoutMilliSecond);
  }

  if (sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId === undefined) {
    httpClient
      .get('Admin/DocumentType/GetSelectOptionList?moduleId=' + sectionComponent.props.moduleId)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
            componentDataSource.DocumentTypeId = dataSource;
            sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
            sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', dataSource[0].Value);
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    setTimeout(() => {
      let dataSource = sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId;
      let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
      componentDataSource.DocumentTypeId = dataSource;
      sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
      sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId[0].Value);
    }, config.setTimeoutMilliSecond);
  }

  let searchParameter = sectionComponent.props.searchParameter || pageComponent?.state?.searchParameter;
  if (searchParameter?.adjoiningPropertyId) {
    httpClient
      .get('Business/AdjoiningPropertyDocumentFolder/GetSelectOptionList?adjoiningPropertyId=' + searchParameter.adjoiningPropertyId)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            const uploadDoc = sectionComponent.child.current?.uploadDocument.current;
            let componentDataSource = { ...uploadDoc?.state.componentDataSource };
            componentDataSource.AdjoiningPropertyDocumentFolderId = dataSource;
            uploadDoc?.setState({ componentDataSource }, () => {
              if (uploadDoc?.state.adjoiningPropertyDocumentFolderId !== null && uploadDoc?.state.adjoiningPropertyDocumentFolderId !== undefined) {
                uploadDoc?.formRef.current?.setFieldValue('AdjoiningPropertyDocumentFolderId', uploadDoc.state.adjoiningPropertyDocumentFolderId);
              } else {
                uploadDoc?.formRef.current?.setFieldValue('AdjoiningPropertyDocumentFolderId', dataSource[0].Value);
              }
            });
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    httpClient
      .get('Business/JobDocumentFolder/GetSelectOptionList?jobId=' + sectionComponent.props.searchParameter.jobId)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            const uploadDoc = sectionComponent.child.current?.uploadDocument.current;
            let componentDataSource = { ...uploadDoc?.state.componentDataSource };
            componentDataSource.JobDocumentFolderId = dataSource;
            uploadDoc?.setState({ componentDataSource }, () => {
              if (uploadDoc?.state.jobDocumentFolderId !== null && uploadDoc?.state.jobDocumentFolderId !== undefined) {
                uploadDoc?.formRef.current?.setFieldValue('JobDocumentFolderId', uploadDoc.state.jobDocumentFolderId);
              } else {
                uploadDoc?.formRef.current?.setFieldValue('JobDocumentFolderId', dataSource[0].Value);
              }
              // folder数据到达后，补上之前因数据缺失未赋值的folder
              if (typeof uploadDoc?.reApplyFolderToAllFiles === 'function') uploadDoc.reApplyFolderToAllFiles();
            });
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }

  const currentJobId = sectionComponent.props.searchParameter?.jobId || pageComponent?.state?.jobData?.JobId;
  let documentNameTemplateUrl = 'Admin/DocumentNameTemplate/GetAutoCompleteList?moduleId=' + sectionComponent.props.moduleId;
  if (currentJobId) {
    // JobDetail 上传文档时由后端按当前 Job Type 筛选可用的命名模板。
    documentNameTemplateUrl += '&jobId=' + currentJobId;
  }

  httpClient
    .get(documentNameTemplateUrl)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          dataSource = dataSource.filter(item => item.Value !== 0);
          const uploadDoc = sectionComponent.child.current?.uploadDocument.current;
          if (uploadDoc) {
            uploadDoc.setState({ fileNameOptions: dataSource, filteredOptions: dataSource }, () => {
              if (typeof uploadDoc?.initDocNameTemplatesIfNeeded === 'function') {
                uploadDoc.initDocNameTemplatesIfNeeded().then(() => {
                  uploadDoc.autoApplyTemplatesToAllFiles();
                });
              }
            });
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function referralJobAddBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ uploadType: '' });
  sectionComponent.child.current?.setState({ uploadDocumentShow: true });
  sectionComponent.child.current?.uploadDocument.current?.setState({
    submitting: false,
  });

  httpClient
    .get('Business/JobDocumentFolder/GetSelectOptionList?jobId=' + sectionComponent.props.searchParameter.jobId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
          componentDataSource.JobDocumentFolderId = dataSource;
          sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
          if (sectionComponent.child.current?.uploadDocument.current?.state.jobDocumentFolderId !== null && sectionComponent.child.current?.uploadDocument.current?.state.jobDocumentFolderId !== undefined) {
            sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('JobDocumentFolderId', sectionComponent.child.current?.uploadDocument.current?.state.jobDocumentFolderId);
          } else {
            sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('JobDocumentFolderId', dataSource[0].Value);
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//拖拽文档触发
export function dropDocument({ files, component } = {}) {
  let fileList = component.state.fileList;
  let date = new Date().getTime();
  const filesArray = Array.from(files);
  const shareControlValues = component.formRef.current?.getFieldValue('ShareControl') || [];
  setTimeout(() => {
    filesArray.map((file, i) => {
      let have = false;
      fileList.map((oldFile, j) => {
        if (oldFile.name === file.name && oldFile.size === file.size) {
          have = true;
        }
      })
      if (!have) {
        file.uid = 'rc-upload-' + date + '-' + i;
        file.DocumentTypeId = component.formRef.current?.getFieldValue('DocumentTypeId');
        if (component.state.jobDocumentFolderId != null) {
          file.JobDocumentFolderId = component.state.jobDocumentFolderId;
          file.folderFromDrag = true;
        } else {
          file.JobDocumentFolderId = component.formRef.current?.getFieldValue('JobDocumentFolderId');
        }
        if (component.state.adjoiningPropertyDocumentFolderId != null) {
          file.AdjoiningPropertyDocumentFolderId = component.state.adjoiningPropertyDocumentFolderId;
        } else {
          file.AdjoiningPropertyDocumentFolderId = component.formRef.current?.getFieldValue('AdjoiningPropertyDocumentFolderId');
        }
        file.ShareClientPortal = shareControlValues.includes(1);
        file.ShareOnsiteJob = shareControlValues.includes(2);
        file.ShareTrackingPage = shareControlValues.includes(3);
        file.shareValues = [...shareControlValues];
        if (file.size / 1024 / 1024 > config.fileUploadLimit) {
          file.status = 'error';
          file.tip = file.name + ' size larger than ' + config.fileUploadLimit + 'M';
        }
        if (file.size === 0) {
          file.status = 'error';
          file.tip = file.name + ' - This file is 0KB and will not be uploaded. Make sure not to select or drag files from a zipped file/folder.';
        }
        fileList.push(file);
      }
    })
    component.setState({ fileList });
    component.setState({ onDragEnterCLass: '' });
  }, config.setTimeoutMilliSecond * 5);
}

//收起所有folder
export function collapseAllFolders({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  const currentCollapseStates = sectionComponent.child.current?.state.folderCollapseStates || {};
  const newCollapseStates = sectionComponent.child.current?.state.data.reduce((states, folder) => {
    return { ...states, [folder.key]: true };
  }, currentCollapseStates);
  sectionComponent.child.current?.setState({
    folderCollapseStates: newCollapseStates
  });
}

//获取DocumentTypeId数据源（优先从缓存读，没有则从API获取）
function getDocumentTypeIdData(sectionComponent, pageComponent) {
  return new Promise((resolve) => {
    let cached = sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId || sectionComponent.state.componentDataSource?.DocumentTypeId;
    if (cached && cached.length > 0) {
      resolve(cached);
    } else {
      httpClient
        .get('Admin/DocumentType/GetSelectOptionList?moduleId=' + sectionComponent.props.moduleId)
        .then(({ data }) => {
          if (data.result && data.data.length > 0) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          resolve([]);
        });
    }
  });
}

//打开ChangeType弹窗
export function openChangeType({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ changeTypeShow: true });
    getDocumentTypeIdData(sectionComponent, pageComponent).then((data) => {
      if (data.length > 0) {
        // 从选中的文档中获取当前的DocumentTypeId
        let selectedKeys = sectionComponent.child.current?.state.selectedRowKeys || [];
        let selectedDocumentTypeId = null;
        sectionComponent.child.current?.state.data?.forEach(folder => {
          folder.DocumentList?.forEach(doc => {
            if (selectedKeys.indexOf(doc.key) >= 0 && doc.DocumentTypeId != null && doc.DocumentTypeId !== 0) {
              selectedDocumentTypeId = doc.DocumentTypeId;
            }
          });
        });
        let defaultValue = selectedDocumentTypeId || data[0].Value;
        sectionComponent.child.current?.changeType.current?.setState({ data });
        sectionComponent.child.current?.changeType.current?.formRef.current?.setFieldsValue({ 'DocumentTypeId': defaultValue });
      }
    });
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开ChangeStatus弹窗
export function openChangeStatus({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ changeStatusShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.changeStatus.current?.getDocumentStatus();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开SubJob ChangeType弹窗
export function openSubJobChangeType({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ changeTypeShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.changeType.current?.getDocumentType();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开ChangeFolder弹窗
export function openChangeFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let data = [];
    sectionComponent.child.current?.state.data.map((folder, i) => {
      folder.DocumentList.map((document, j) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(document.key) >= 0) {
          data.push(lodash.cloneDeep(document));
        }
      })
    })

    sectionComponent.child.current?.setState({ changeFolderShow: true });
    sectionComponent.child.current?.changeFolder.current?.setState({ data });

    httpClient
      .get('Business/JobDocumentFolder/GetList?jobId=' + pageComponent.state.jobData.JobId)
      .then(({ data }) => {
        if (data.result) {
          let options = [];
          options.push({ Key: '- Select Document Folder -', Value: 0, Color: null, Data: null });
          data.data.map(item => {
            options.push({ Key: item.Name, Value: item.key, Color: null, Data: null });
          });
          let componentDataSource = [];
          componentDataSource.DocumentTypeId = sectionComponent.state.componentDataSource.DocumentTypeId;
          componentDataSource.JobDocumentFolderId = options;
          let componentDefaultValue = [];
          componentDefaultValue.DocumentTypeId = componentDataSource.DocumentTypeId[0].Value;
          componentDefaultValue.JobDocumentFolderId = componentDataSource.JobDocumentFolderId[0].Value;
          sectionComponent.child.current?.changeFolder.current?.setState({ componentDataSource, componentDefaultValue });
          sectionComponent.child.current?.changeFolder.current?.formRef.current?.setFieldsValue({ 'JobDocumentFolderId': componentDefaultValue.JobDocumentFolderId });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开ShareControl弹窗
export function openShareControl({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let data = [];
    sectionComponent.child.current?.state.data.map((folder, i) => {
      folder.DocumentList.map((document, j) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(document.key) >= 0) {
          data.push(lodash.cloneDeep(document));
        }
      })
    })

    sectionComponent.child.current?.setState({ shareControlShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.shareControl.current?.setState({
        data,
        selectAll: {
          ShareClientPortal: false,
          ShareOnsiteJob: false,
          ShareTrackingPage: false,
        }
      });
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开回收站弹窗
export function openRecycleBin({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ recycleBinShow: true });
  let searchParameter = { ...sectionComponent.state.searchParameter };
  let jobId = sectionComponent.props.searchParameter.jobId;
  httpClient
    .get('/Business/Document/GetRecycleBinList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.recycleBin.current?.setState({ data: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//打开SubJob回收站弹窗
export function openSubJobRecycleBin({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ recycleBinShow: true });
  let searchParameter = { ...sectionComponent.state.searchParameter };
  let subJobId = sectionComponent.props.searchParameter.subJobId;
  httpClient
    .get('/Business/Document/GetSubJobRecycleBinList?subJobId=' + subJobId)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.recycleBin.current?.setState({ data: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//管理JobDocumentFolder
export function openManageJobDocumentFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getJobDocumentFolderList();
  // sectionComponent.child.current?.child.map((folder, i) => {
  //   console.log(i);
  //   sectionComponent.child.current?.manageFolder.current?.getJobDocumentFolderList();
  // })
}

//管理AdjoiningPropertyDocumentFolder
export function openManageAdjoiningPropertyDocumentFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getAdjoiningPropertyDocumentFolderList();
}

//打开AdjoiningProperty回收站弹窗
export function openAdjoiningPropertyRecycleBin({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ recycleBinShow: true });
  let adjoiningPropertyId = sectionComponent.props.searchParameter.adjoiningPropertyId;
  httpClient
    .get('/Business/Document/GetAdjoiningPropertyRecycleBinList?adjoiningPropertyId=' + adjoiningPropertyId)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.recycleBin.current?.setState({ data: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//打开AdjoiningProperty ChangeFolder弹窗
export function openAdjoiningPropertyChangeFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let data = [];
    sectionComponent.child.current?.state.data.map((folder, i) => {
      folder.DocumentList.map((document, j) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(document.key) >= 0) {
          data.push(lodash.cloneDeep(document));
        }
      })
    })

    sectionComponent.child.current?.setState({ changeFolderShow: true });
    sectionComponent.child.current?.changeFolder.current?.setState({ data });

    let adjoiningPropertyId = sectionComponent.props.searchParameter.adjoiningPropertyId;
    Promise.all([
      httpClient.get('Business/AdjoiningPropertyDocumentFolder/GetList?adjoiningPropertyId=' + adjoiningPropertyId),
      getDocumentTypeIdData(sectionComponent, pageComponent)
    ]).then(([folderRes, documentTypeData]) => {
      if (folderRes.data.result) {
        let options = [];
        options.push({ Key: '- Select Document Folder -', Value: 0, Color: null, Data: null });
        folderRes.data.data.map(item => {
          options.push({ Key: item.Name, Value: item.key, Color: null, Data: null });
        });
        let componentDataSource = [];
        componentDataSource.DocumentTypeId = documentTypeData.length > 0 ? documentTypeData : undefined;
        componentDataSource.AdjoiningPropertyDocumentFolderId = options;
        let componentDefaultValue = [];
        componentDefaultValue.DocumentTypeId = componentDataSource.DocumentTypeId !== undefined ? componentDataSource.DocumentTypeId[0].Value : undefined;
        componentDefaultValue.AdjoiningPropertyDocumentFolderId = componentDataSource.AdjoiningPropertyDocumentFolderId[0].Value;
        sectionComponent.child.current?.changeFolder.current?.setState({ componentDataSource, componentDefaultValue });
        sectionComponent.child.current?.changeFolder.current?.formRef.current?.setFieldsValue({ 'AdjoiningPropertyDocumentFolderId': componentDefaultValue.AdjoiningPropertyDocumentFolderId });
      } else {
        globalFunction.handleResultError(folderRes.data, pageComponent);
      }
    }).catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
  } else {
    message.warning('You must select at least one document.');
  }
}

//清除选择的key
function clearSelectedRowKeys(sectionComponent) {
  sectionComponent.child.current?.setState({ selectedRowKeys: [] });
  sectionComponent.child.current?.child.map((folder, i) => {
    folder.current?.setState({ selectedRowKeys: [] });
  })
}

//批量下载
export function batchDownload({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.download({ method: 'post', url: '/Business/Document/BatchDownload', data: { DocumentIdList: sectionComponent.child.current?.state.selectedRowKeys }, filename: pageComponent.state.jobData.JobNum + ' Documents.zip', save: true });
    clearSelectedRowKeys(sectionComponent);
  } else {
    message.warning('You must select at least one document.');
  }
}

export function copyToEndorsed({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length === 0) {
    message.warning('You must select at least one document.');
    return;
  }

  // 收集选中的文档 Id 列表
  let documentIdList = [];
  sectionComponent.child.current?.state.data.map((folder) => {
    folder.DocumentList.map((item) => {
      if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(item.key) >= 0) {
        documentIdList.push(item.key);
      }
    })
  });

  httpClient
    .post('Business/JobApprovedDoc/BatchCopyToApprovedDoc', {
      JobId: pageComponent.state.jobData.JobId,
      DocumentIdList: documentIdList,
      Group: 'Building Permit',
    })
    .then(({ data }) => {
      if (data.result) {
        clearSelectedRowKeys(sectionComponent);
        let approvedDocSection = globalFunction.getSectionComponent(pageComponent, 'JobApprovedDoc');
        if (approvedDocSection !== null) {
          approvedDocSection.getSectionDataByDefault();
        }
        Modal.success({
          title: 'Confirm',
          content: 'Documents copied to the Endorsed Document section',
        });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//批量删除
export function batchDelete({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/Document/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one document.');
  }
}

//Document列表刷新
export function refreshDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.getSectionDataByDefault();
  clearSelectedRowKeys(sectionComponent);
  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = true;
    sectionComponent.setState(sectionComponent.state.section);
  }, 100);

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = false;
    sectionComponent.setState(sectionComponent.state.section);
  }, 1100);
}

export function downloadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Business/Document/Download/' + parameter.key, data: null, filename: parameter.Name, save: true });
}

//打开照片墙
export function openGallery({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  // sectionComponent.getSectionDataByDefault();
  setTimeout(() => {
    sectionComponent.child.current?.setState({ galleryShow: true });
  }, 100);
  sectionComponent.child.current?.gallery.current?.getAllImage();
  // sectionComponent.child.current?.gallery.current?.getVideoImage();
}

//切换SubJobImage的ShowOnReport
export function changeSubJobImageShowOnReport({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .post('Business/SubJob/ChangeSubJobImageShowOnReport/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        console.log(sectionComponent);
        let newData = sectionComponent.state.data.map(image => {
          if (image.key === parameter.key) {
            image.ShowOnReport = !image.ShowOnReport;
          }
          return image;
        });

        setTimeout(() => {
          sectionComponent.setState({ data: [] });
          sectionComponent.setState({ data: newData });
        }, config.setTimeoutMilliSecond);
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function sendEmail({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let selectedDocumentList = [];
    sectionComponent.child.current?.state.data.map((folder) => {
      folder.DocumentList.map((item) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(item.key) >= 0) {
          selectedDocumentList.push(item);
        }
      })
    })

    // Document 发信为 Job 场景，重置 Invoice 标记，避免沿用上一次 Invoice MailMerge 的状态
    pageComponent.setState({ sendEmailShow: true, selectedDocumentList, sendEmailInvoiceId: null, sendEmailSource: null });
    setTimeout(() => {
      pageComponent.calculateSelectedDocumentTotalSize();
      if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ModuleConfig.FromEmailAddress)) {
        pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ From: 'My Email' });
      }
    }, config.setTimeoutMilliSecond);

    if (pageComponent.props.authUser.EmailSignature !== null) {
      setTimeout(() => {
        setEmailDefaultInfo(parameter, pageComponent)
      }, config.setTimeoutMilliSecond);
    } else {
      httpClient
        .get('Admin/CompanyUser/' + pageComponent.props.authUser.CompanyUserId)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.props.authUser.EmailSignature = data.data.EmailSignature;
            pageComponent.props.setAuthUser(pageComponent.props.authUser);
            setTimeout(() => {
              setEmailDefaultInfo(parameter, pageComponent);
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开打水印窗口
export function openStamping({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.setState({ stampingShow: true });
    setTimeout(() => {
      sectionComponent.child.current?.stamping.current?.setDocumentDataSource();
      sectionComponent.child.current?.stamping.current?.getStampConfigDataSource();
      sectionComponent.child.current?.stamping.current?.getFolderDataSource();
      sectionComponent.child.current?.stamping.current?.getShareControlDataSource();
      sectionComponent.child.current?.stamping.current?.getDocumentTypeDataSource();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one document.');
  }
}

//打开合并pdf窗口
export function openCombinePDF({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documents = [];
  sectionComponent.child.current?.state.data.map((folder) => {
    folder.DocumentList.map((item) => {
      let extension = globalFunction.getExtension(item.Name).toLowerCase();
      if (sectionComponent.child.current?.state.selectedRowKeys.includes(item.key) && extension === '.pdf') {
        documents.push(item);
      }
    })
  })
  if (documents.length !== 0) {
    sectionComponent.child.current?.setState({ combinePdfShow: true });
    setTimeout(() => {
      const combinePDF = sectionComponent.child.current?.combinePDF.current;
      if (!combinePDF) return;
      combinePDF.selectedDocumentNameTemplate = null;
      combinePDF.formRef.current?.setFieldValue('Name', pageComponent.state.jobData.ModuleConfig?.CombinePdfDefaultName);
      combinePDF.formRef.current?.setFieldValue('JobDocumentFolderId', 0);
      combinePDF.formRef.current?.setFieldValue('DocumentTypeId', 0);
      combinePDF.formRef.current?.setFieldValue('Comment', '');
      combinePDF.formRef.current?.setFieldValue('DeleteOriginal', false);
      combinePDF.setDocumentDataSource();
      combinePDF.getStampConfigDataSource();
      combinePDF.getFolderDataSource();
      combinePDF.getShareControlDataSource();
      combinePDF.getDocumentTypeDataSource();
      combinePDF.getDocumentNameTemplateDataSource();
    }, config.setTimeoutMilliSecond);
  } else {
    message.warning('You must select at least one document.');
  }
}

//云编辑
export function cloudEdit({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.CloudFileId !== null || parameter.CloudDocId !== null) {
    return;
  }
  const newData = sectionComponent.child.current?.state.data.map((folder) => {
    const newDocumentList = folder.DocumentList.map((item) => {
      if (parameter.key === item.key) {
        return { ...item, IconFormat: [{ actionType: 'CloudEdit', iconIndex: 2 }] };
      }
      return item;
    });
    return { ...folder, DocumentList: newDocumentList };
  });
  sectionComponent.child.current?.setState({ data: newData });

  let form = {};
  form.DocumentId = parameter.key;

  httpClient
    .post('Business/Document/CloudEdit/', form)
    .then(({ data }) => {
      let iconIndex = 0;
      let cloudEditShow = false;
      let href = null;
      console.log(data);
      if (data.result) {
        switch (data.code) {
          case 200:
            switch (pageComponent.props.authUser.Company.CloudEditSyncProvider) {
              case 'Dropbox':
              case 'Microsoft 365':
                href = data.data;
                iconIndex = 1;
                cloudEditShow = false;
                break;
            }
            break;
          case 201:
            switch (pageComponent.props.authUser.Company.CloudEditSyncProvider) {
              case 'Dropbox':
              case 'Microsoft 365':
                href = data.data;
                iconIndex = 1;
                cloudEditShow = false;
                break;
            }
            break;
          case 300:
            iconIndex = 0;
            message.info(data.message);
            cloudEditShow = false;
            break;
          default:
            iconIndex = 0;
            message.error(data.message);
            cloudEditShow = false;
            break;
        }
      } else {
        iconIndex = 0;
        message.error(data.message);
      }

      //改变图标
      switch (data.code) {
        case 200:
          setTimeout(() => {
            const updatedData = sectionComponent.child.current?.state.data.map((folder) => {
              const updatedDocumentList = folder.DocumentList.map((item) => {
                if (parameter.key === item.key) {
                  return { ...item, IconFormat: [{ actionType: 'CloudEdit', iconIndex: iconIndex, href }] };
                }
                return item;
              });
              return { ...folder, DocumentList: updatedDocumentList };
            });
            sectionComponent.child.current?.setState({ data: updatedData, cloudEditShow, href, fileName: parameter.Name });
          }, 2000);
          break;

        default:
          const updatedData = sectionComponent.child.current?.state.data.map((folder) => {
            const updatedDocumentList = folder.DocumentList.map((item) => {
              if (parameter.key === item.key) {
                return { ...item, IconFormat: [{ actionType: 'CloudEdit', iconIndex: iconIndex, href }] };
              }
              return item;
            });
            return { ...folder, DocumentList: updatedDocumentList };
          });
          sectionComponent.child.current?.setState({ data: updatedData, cloudEditShow, href, fileName: parameter.Name });
          break;
      }
    })
    .catch(function (error) {
      message.error('Error!');
      //改变图标
      const updatedData = sectionComponent.child.current?.state.data.map((folder) => {
        const updatedDocumentList = folder.DocumentList.map((item) => {
          if (parameter.key === item.key) {
            return { ...item, IconFormat: [{ actionType: 'CloudEdit', iconIndex: 0 }] };
          }
          return item;
        });
        return { ...folder, DocumentList: updatedDocumentList };
      });
      sectionComponent.child.current?.setState({ data: updatedData });
    });
}

//自动完成名称后填入其他信息
export function fileNameOnSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.data.DocumentTypeId !== null) {
    formComponent.formRef.current?.setFieldValue('DocumentTypeId', parameter.data.DocumentTypeId);
  }
  if (parameter.data.CompanyDocumentFolderId !== null) {
    let folderName = parameter.data.CompanyDocumentFolderName;
    let documentFolderId = 0;
    formComponent.state.componentDataSource.JobDocumentFolderId.map((jobDocumentFolder, i) => {
      if (jobDocumentFolder.Key.toLowerCase() === folderName.toLowerCase()) {
        documentFolderId = jobDocumentFolder.Value;
      }
    })
    formComponent.formRef.current?.setFieldValue('JobDocumentFolderId', documentFolderId);
  }
  formComponent.formRef.current?.setFieldsValue({ ShareClientPortal: parameter.data.ClientAccess, ShareOnsiteJob: parameter.data.ContractorAccess, ShareTrackingPage: parameter.data.TrackingPageAccess });
}

//取消所有选项
export function unSelectAll({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    clearSelectedRowKeys(sectionComponent);
  }
}

//展开菜单
export function showDocumentContextMenu({ e, parameter, sectionComponent, pageComponent } = {}) {
  sectionComponent.child.current?.setState({ event: e, documentContextMenuShow: true, documentId: parameter.DocumentId, currentDocument: parameter });
  sectionComponent.child.current?.documentVersion.current?.setState({ data: [] });
  e.preventDefault();
  return false;
}

//选择 DocumentType 后设置Access
export function documentTypeIdOnChange({ sectionName, parameter, data, formComponent, sectionComponent, pageComponent, uie } = {}) {
  formComponent.formRef.current?.setFieldsValue({ ShareClientPortal: data.Data?.ClientAccess, ShareOnsiteJob: data.Data?.ContractorAccess, ShareTrackingPage: data.Data?.TrackingPageAccess });
}

export function quickChangeStatus({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let documentlistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.DocumentList.map((documentlist, j) => {
      if (documentlist.key === parameter.key) {
        documentlist.Loading = true;
      }
      return documentlist;
    });
    return folder;
  });
  setTimeout(() => {
    sectionComponent.child.current?.setState({ data: [] });
    sectionComponent.child.current?.setState({ data: documentlistData });

    //写后台
    httpClient
      .put('Business/Document/QuickChangeStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          let documentlistData = sectionComponent.child.current?.state.data.map((folder, i) => {
            folder.DocumentList.map((documentlist, k) => {
              if (documentlist.key === parameter.key) {
                documentlist.DocumentStatusId = data.data.DocumentStatusId;
                documentlist.DocumentStatusName = data.data.DocumentStatusName;
                documentlist.DocumentStatusBackgroundColor = data.data.DocumentStatusBackgroundColor;
                documentlist.Loading = false;
              }
              return documentlist;
            });
            return folder;
          });
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: documentlistData });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

export function showStatusMenu({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ event: e, statusMenuShow: true, documentStatusSetId: parameter.DocumentStatusId, documentId: parameter.DocumentId });
  e.preventDefault();
  return false;
}

export function getDocumentStatusSets({ sectionComponent, pageComponent } = {}) {
  //写后台
  httpClient
    .get('Admin/DocumentStatus/GetList')
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.child.current?.setState({ documentStatusSets: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function changeStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  //写后台
  httpClient
    .put('Business/Document/ChangeStatus', { key: parameter.key, DocumentStatusId: parameter.documentStatusId })
    .then(({ data }) => {
      if (data.result) {
        let documentlistData = sectionComponent.child.current?.state.data.map((folder, i) => {
          folder.DocumentList.map((documentlist, k) => {
            if (documentlist.key === parameter.key) {
              documentlist.DocumentStatusId = data.data.DocumentStatusId;
              documentlist.DocumentStatusName = data.data.DocumentStatusName;
              documentlist.DocumentStatusBackgroundColor = data.data.DocumentStatusBackgroundColor;
              documentlist.Loading = false;
            }
            return documentlist;
          });
          return folder;
        });
        sectionComponent.child.current?.setState({ data: [] });
        sectionComponent.child.current?.setState({ statusMenuShow: false, data: documentlistData });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function clientJobTemplateDocumentAddBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ uploadDocumentShow: true, uploadType: 'ClientJobTemplateDocument' });
  sectionComponent.child.current?.uploadDocument.current?.getDocumentTypeDataSource(pageComponent.state.moduleId);
  sectionComponent.child.current?.uploadDocument.current?.setState({ showDefaultFolder: true });
}

export function jobDataTemplateDocumentAddBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ uploadDocumentShow: true, uploadType: 'JobDataTemplateDocument' });
  sectionComponent.child.current?.uploadDocument.current?.getDocumentTypeDataSource(pageComponent.state.moduleId);
  sectionComponent.child.current?.uploadDocument.current?.setState({ showDefaultFolder: true });
}

export function deleteDocument({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .delete('Business/Document/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
        let functionName = 'delete' + sectionName + 'Run';
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function editJobDataTemplateDocument({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get('Business/Document/GetJobDataTemplateDetail/' + parameter.key + '?jobDataTemplateId=' + pageComponent.props.jobDataTemplateId)
      .then(({ data }) => {
        if (data.result) {
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0].Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  break;
              }
            });
          });

          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
          sectionComponent.setState({ dataLoading: false });
          sectionComponent.setState({ isFormModified: false });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function editClientJobTemplateDocument({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get('Business/Document/GetClientJobTemplateDetail/' + parameter.key + '?clientJobTemplateId=' + pageComponent.props.clientJobTemplateId)
      .then(({ data }) => {
        if (data.result) {
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0].Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  break;
              }
            });
          });

          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
          sectionComponent.setState({ dataLoading: false });
          sectionComponent.setState({ isFormModified: false });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//打开打Manage Share Link窗口
export function openManageShareLink({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageShareLinkShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageShareLink.current?.getShareLinkData();
    // sectionComponent.child.current?.manageShareLink.current?.resetData();
  }, config.setTimeoutMilliSecond);
}


//打开打Copy Docs窗口
export function openCopyDocs({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ copyDocsShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.copyDocs.current?.getLibraryDocumentData();
  }, config.setTimeoutMilliSecond);
}
